import { FormHelperText, Stack } from "@mui/material";
import React, {forwardRef} from "react";
import { TelInput } from "../input/PhoneInput";

interface AddressFormTelInputProps {
  error?: boolean;
  onChange?: any;
  label?: string;
  required?: boolean;
  helperText?: string;
  value?: any;
  defaultValue?: any;
  stackStyle?: any;
}

export const AddressFormTelInput = forwardRef((props: AddressFormTelInputProps, ref) => {
  const { error = false, onChange, label, required = false, helperText, stackStyle,  ...rest } = props;

  return (
    <Stack flex={1} style={stackStyle}>
      <TelInput
        onChange={onChange}
        defaultCountry={"US"}
        focusOnSelectCountry
        label={label}
        error={error}
        required={required}
        {...rest}
      />
      { helperText && <FormHelperText error={error}>{helperText}</FormHelperText> }
    </Stack>
  );
});
